import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, conditionDocumentalCampaignId) {
  return apiFetch({ endPoint: 'ConditionDocumentalCampaign/DeleteUoToConditionDocumentalCampaign/' + conditionDocumentalCampaignId + '?organizedUnitId=' + organizedUnitId, method: 'DELETE', body: null, token: token })
}
